import { TextField, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { ReactSetStateFunction } from "@utils/utility-types";
import { useEffect, useState } from "react";

interface Props {
  /** The email of the member to be deleted */
  membersEmail: string;

  /** Setter for shouldDisableContinueButton */
  setShouldDisableContinueButton: ReactSetStateFunction<boolean>;
}

/** Content for step 3 of delete member */
export function DeleteMemberStep3({
  membersEmail,
  setShouldDisableContinueButton,
}: Props): React.JSX.Element {
  const [text, setText] = useState<string>("");

  useEffect(() => {
    setShouldDisableContinueButton(membersEmail !== text);
  }, [membersEmail, setShouldDisableContinueButton, text]);

  return (
    <Text variant="bodyL">
      To confirm deletion, enter the member's email address{" "}
      <Box component="b" sx={{ color: "error.main", wordBreak: "break-word" }}>
        {membersEmail}
      </Box>{" "}
      below:
      <TextField
        variant="outlined"
        text={text}
        onTextChanged={setText}
        fullWidth
        sx={{ mt: 2 }}
      />
    </Text>
  );
}
